/**
 * ALT → CSS hex (swatch fill only).
 * Keys match product image ALT values — not storefront labels.
 *
 * Label → canonical Polish → ALT: snippets/variant-color-map.liquid only.
 */
window.ColorSwatchConfig = window.ColorSwatchConfig || {
  hex: {
    black: '#000000',
    white: '#ffffff',
    mist: '#2A2A2A',
    gray: '#D6D6D6',
    pink: '#e8a4b4',
    'veri peri': '#6667ab',
    lilia: '#c9a8d4',
    'jasny beż': '#d6c4a8',
  },
};
